import React from 'react';
import {
    NavLink,
    Link
} from 'react-router-dom'

import { LayoutOne } from "../Layout";


class ProjectGrid extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        let projects = this.props.filteredProjects;

        let projectsData = projects.map((item, key) => {
            let index = key <= LayoutOne.length - 1 ? key : key % (LayoutOne.length - 1);
            let img1 = item.listing_images_1 ? item.listing_images_1.url : false;
            let img2 = item.listing_images_2 ? item.listing_images_2.url : false;
            let cls = item.listing_view ? item.listing_view : 'fig-p';

            return img1 ? (
                <figure className={cls}>
                    <Link className="link project-link" exact to={`${process.env.PUBLIC_URL}/project/${item.post_name}`}></Link>

                    <img src={img1} alt={item.post_title} title={item.post_title} />
                    <img src={img2} alt={item.post_title} title={item.post_title} />

                    <figcaption>
                        <h5 className="--title">{item.post_title}</h5>
                        <p className="--caption">{item.project_sub_heading}</p>
                    </figcaption>
                </figure>
            ) : []
        })
        return (
            // <section className="section" data-logo="hide">
            <section>
                <div className="mole__project-grid fullW">
                    <div className="main-container">
                        <div className="inner-grid fullW">
                            {projectsData}
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default ProjectGrid;



// WEBPACK FOOTER //
// ./src/components/Projects/Grid/ProjectGrid.js